import React from "react";
import Modal from "react-modal";
//import Inc from "./Include";
import './Hello.scss';

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		zIndex: "100",
		backgroundColor: "rgba(0, 0, 0, 0.5)"
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		padding: "0",
		width:"280px",
		minHeight:"420px",
		transform: "translate(-50%, -50%)"
	}
};

function Sorry ({close,isOpen}){
    const afterOpenModal = ()=>{
		
    }

    return (
		<Modal
			isOpen={isOpen}
			onRequestClose={close}
			onAfterOpen={afterOpenModal}
			style={customStyles}
			shouldCloseOnOverlayClick={true}
		>
		<div id="hello">
			<div className="face">
				<i className="fas fa-fish"></i> メンテナンス中
			</div>
            <div className="text">
                <p>サーバーはメンテナンス中もしくはトラブルの真っ最中です。</p>
                <p>少し時間をおいてから再度試してみて下さい。</p>
            </div>
            <div className="btns">
                <button
                    className="ok"
                    onClick={close}
                >良い</button>
            </div>

		</div>
		</Modal>
	);
}

export default Sorry;